import React from "react";
//@ts-ignore
import BpmnModeler from "bpmn-js/lib/Modeler";
//@ts-ignore
import { getBusinessObject } from "bpmn-js/lib/util/ModelUtil";
import MenuItem from "@mui/material/MenuItem";
import { SelectChangeEvent } from "@mui/material/Select";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import {
  ProcessModelDataTypes,
} from "hooks/useBpmnModeler/useBpmnJsModeler";
import RunTimeAssignmentFields from "./RunTimeAssignmentFields";
import TimerDefinitionSettings from "./TimerDefinitionSettings";
import { generateISODurationString } from "../../../../../../../utils/DateUtils";

import { useSnackbar, useTranslations } from "hooks";
import { getTranslation } from "common";
import {
  Stack,
  TextField,
  Button,
  Typography,
  ListItemButton,
  ListItemText,
  Collapse,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { ExtensionElementType } from "model/processModel";

interface SpecificPropertiesPanelTypes {
  toggleSpecificPropertiesAccordian: boolean;
  setToggleSpecificPropertiesAccordian: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  element: any;
  modeler: BpmnModeler;
  timerType: string;
  setTimerType: (value: string) => void;
  timeDateValue: Date | null;
  setTimeDateValue: (value: Date | null) => void;
  timeDurationValue: Date | string;
  setTimeDurationValue: (value: Date | string) => void;
  processModelData: ProcessModelDataTypes;
  getRequestBodyForExtensionElements: () => Array<ExtensionElementType>;
  setProcessModelData: (data: ProcessModelDataTypes) => void;
  // getSelectedLanguage: () => string;
  openDiagram: (xml: string, shouldShowInTheViewPort: boolean) => void;
  selectedDuration: {
    months: number;
    weeks: number;
    days: number;
    hours: number;
    minutes: number;
  };
  setSelectedDuration: (value: {
    months: number;
    weeks: number;
    days: number;
    hours: number;
    minutes: number;
  }) => void;
}

const SpecificPropertiesPanel = (props: SpecificPropertiesPanelTypes) => {
  const {
    toggleSpecificPropertiesAccordian,
    setToggleSpecificPropertiesAccordian,
    element,
    modeler,
    timerType,
    setTimerType,
    timeDateValue,
    setTimeDateValue,
    processModelData,
    getRequestBodyForExtensionElements,
    setProcessModelData,
    // getSelectedLanguage,
    openDiagram,
    selectedDuration,
    setSelectedDuration,
  } = props;
  const translations = useTranslations();
  const { sendSnack } = useSnackbar();

  const getShouldShowTimerTypeField = () => {
    const bo = getBusinessObject(element);
    const isTimerEvent = bo.eventDefinitions && bo.eventDefinitions.length;

    return (
      (element.type === "bpmn:StartEvent" && isTimerEvent) ||
      element.type === "bpmn:IntermediateCatchEvent" ||
      isTimerEvent
    );
  };
  const currentDate = new Date();
  const minDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate()
  );
  const handleChangeTimerType = (e: SelectChangeEvent<string>) => {
    setTimerType(e.target.value);
    if (e.target.value === "") {
      const bo = getBusinessObject(element);
      let eventDefinition = bo.eventDefinitions[0];

      delete eventDefinition["timeDuration"];
      delete eventDefinition["timeCycle"];
      delete eventDefinition["timeDate"];
      modeler.get<any>("modeling").updateProperties(element, {
        eventDefinitions: [eventDefinition],
      });
    }
  };

  const onSaveDate = (timeDateValue: Date | null) => {
    let moddle: any = modeler.get("moddle");
    const bo = getBusinessObject(element);
    const isFormalExpressionExist = bo.eventDefinitions[0]?.timeDate;
    if (timeDateValue) {
      if (isFormalExpressionExist && timeDateValue) {
        let eventDefinition = bo.eventDefinitions[0];
        eventDefinition.timeDate.body = new Date(timeDateValue).toISOString();

        delete eventDefinition["timeDuration"];
        delete eventDefinition["timeCycle"];

        modeler.get<any>("modeling").updateProperties(element, {
          eventDefinitions: [eventDefinition],
        });
        sendSnack({
          message: getTranslation(translations, "generic.model_update.caption"),
          type: "success",
        });
      } else {
        let formalExpression = moddle.create("bpmn:FormalExpression", {
          body: new Date(timeDateValue).toISOString(),
        });

        let eventDefinition = bo.eventDefinitions[0];

        delete eventDefinition["timeDuration"];
        delete eventDefinition["timeCycle"];

        eventDefinition["timeDate"] = formalExpression;

        modeler.get<any>("modeling").updateProperties(element, {
          eventDefinitions: [eventDefinition],
        });
        sendSnack({
          message: getTranslation(translations, "generic.model_update.caption"),
          type: "success",
        });
      }
    }
  };

  const onChangeSelectDate = (value: Date | null) => {
    if (value !== null) {
      setTimeDateValue(new Date(value));
    }
  };


  const shouldShowRunTimeAssignmentModeForLane = () => {
    return element.type === "bpmn:Lane";
  };
  const shouldShowRunTimeAssignmentMode = () => {
    return (
      element.type === "bpmn:ExclusiveGateway" ||
      element.type === "bpmn:InclusiveGateway" ||
      element.type === "bpmn:Task"
    );
  };

  const shouldShowSpecificProperties = () => {
    return (
      shouldShowRunTimeAssignmentMode() ||
      shouldShowRunTimeAssignmentModeForLane() ||
      getShouldShowTimerTypeField()
    );
  };

  const shouldShowCycleOption = () => {
    const bo = getBusinessObject(element);
    const isTimerEvent = bo.eventDefinitions && bo.eventDefinitions.length;

    return element.type === "bpmn:StartEvent" && isTimerEvent;
  };

  const onSaveDurationSettings = () => {
    const isoString = generateISODurationString(selectedDuration);
    if (isoString) {
      // const durationValue = generateDurationIsoString(value);

      let moddle: any = modeler.get("moddle");

      const bo = getBusinessObject(element);

      const isFormalExpressionExist = bo.eventDefinitions[0]?.timeDuration;
      if (isFormalExpressionExist) {
        let eventDefinition = bo.eventDefinitions[0];
        eventDefinition.timeDuration.body = isoString;

        delete eventDefinition["timeDate"];
        delete eventDefinition["timeCycle"];

        modeler.get<any>("modeling").updateProperties(element, {
          eventDefinitions: [eventDefinition],
        });

        sendSnack({
          message: getTranslation(translations, "generic.model_update.caption"),
          type: "success",
        });

      } else {
        let formalExpression = moddle.create("bpmn:FormalExpression", {
          body: isoString,
        });

        let eventDefinition = bo.eventDefinitions[0];

        delete eventDefinition["timeDate"];
        delete eventDefinition["timeCycle"];

        eventDefinition["timeDuration"] = formalExpression;

        modeler.get<any>("modeling").updateProperties(element, {
          eventDefinitions: [eventDefinition],
        });

        sendSnack({
          message: getTranslation(translations, "generic.model_update.caption"),
          type: "success",
        });
      }
      // setTimeDurationValue(value);
    }
  };

  const RenderDurationFields = () => {
    return (
      <Stack direction="column" alignItems={"end"} spacing={2}>
        <TextField
          fullWidth
          label={getTranslation(
            translations,
            "pm.propertyeditor.specificproperties.repetition_details.duration.label.month"
          )}
          size="small"
          type="number"
          name="months"
          inputProps={{ min: 0 }}
          value={selectedDuration.months}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setSelectedDuration({
              ...selectedDuration,
              months: Number(e.target.value),
            });
          }}
        />
        <TextField
          fullWidth
          label={getTranslation(
            translations,
            "pm.propertyeditor.specificproperties.repetition_details.duration.label.weeks"
          )}
          size="small"
          type="number"
          name="weeks"
          inputProps={{ min: 0 }}
          value={selectedDuration.weeks}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setSelectedDuration({
              ...selectedDuration,
              weeks: Number(e.target.value),
            });
          }}
        />
        <TextField
          fullWidth
          label={getTranslation(
            translations,
            "pm.propertyeditor.specificproperties.repetition_details.duration.label.days"
          )}
          size="small"
          type="number"
          name="days"
          inputProps={{ min: 0 }}
          value={selectedDuration.days}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setSelectedDuration({
              ...selectedDuration,
              days: Number(e.target.value),
            });
          }}
        />
        <TextField
          fullWidth
          label={getTranslation(
            translations,
            "pm.propertyeditor.specificproperties.repetition_details.duration.label.hours"
          )}
          size="small"
          type="number"
          name="hours"
          inputProps={{ min: 0 }}
          value={selectedDuration.hours}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setSelectedDuration({
              ...selectedDuration,
              hours: Number(e.target.value),
            });
          }}
        />
        <TextField
          fullWidth
          label={getTranslation(
            translations,
            "pm.propertyeditor.specificproperties.repetition_details.duration.label.minutes"
          )}
          size="small"
          type="number"
          name="minutes"
          inputProps={{ min: 0, max: 60 }}
          value={selectedDuration.minutes}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setSelectedDuration({
              ...selectedDuration,
              minutes: Number(e.target.value),
            });
          }}
        />
        <Button
          size="small"
          variant="contained"
          onClick={onSaveDurationSettings}
        >
          {getTranslation(translations, "pm.button.save")}
        </Button>
      </Stack>
    );
  };
  if (!shouldShowSpecificProperties()) {
    return null;
  }
  return (
    <React.Fragment>
      <ListItemButton
        onClick={() => setToggleSpecificPropertiesAccordian((_) => !_)}
      >
        <ListItemText
          primary={getTranslation(
            translations,
            "pm.propertyeditor.specificproperties"
          )}
        />
        {toggleSpecificPropertiesAccordian ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse
        sx={{ pt: 2 }}
        timeout="auto"
        unmountOnExit
        in={toggleSpecificPropertiesAccordian}
      >
        <RunTimeAssignmentFields
          element={element}
          shouldShowRunTimeAssignmentModeForLane={
            shouldShowRunTimeAssignmentModeForLane
          }
          shouldShowRunTimeAssignmentMode={shouldShowRunTimeAssignmentMode}
          modeler={modeler}
          processModelData={processModelData}
          getRequestBodyForExtensionElements={
            getRequestBodyForExtensionElements
          }
          setProcessModelData={setProcessModelData}
          // getSelectedLanguage={getSelectedLanguage}
          openDiagram={openDiagram}
        />
        {getShouldShowTimerTypeField() && (
          <Stack spacing={2}>
            <TextField
              size="small"
              fullWidth
              select
              label={getTranslation(
                translations,
                "pm.propertyeditor.specificproperties.label.timer_type"
              )}
              id="timer-type"
              value={
                !shouldShowCycleOption() && timerType === "Cycle"
                  ? ""
                  : timerType
              }
              onChange={(e) => handleChangeTimerType(e as any)}
            >
              {/* how the user should be able to understand "none" TO DO remove this option empty on start, than if the user selct something -> x for clear */}
              <MenuItem value="">
                {getTranslation(
                  translations,
                  "pm.propertyeditor.specificproperties.repetition_details.type_of_timer.none"
                )}
              </MenuItem>
              <MenuItem value={"Date"}>
                {getTranslation(
                  translations,
                  "pm.propertyeditor.specificproperties.repetition_details.type_of_timer.date"
                )}
              </MenuItem>
              <MenuItem value={"Duration"}>
                {getTranslation(
                  translations,
                  "pm.propertyeditor.specificproperties.repetition_details.type_of_timer.duration"
                )}
              </MenuItem>
              {shouldShowCycleOption() && (
                <MenuItem value={"Cycle"}>
                  {getTranslation(
                    translations,
                    "pm.propertyeditor.specificproperties.repetition_details.type_of_timer.cycle"
                  )}
                </MenuItem>
              )}
            </TextField>

            {timerType === "Date" && (
              <Stack direction="column" alignItems={"end"} spacing={2} >
                <DateTimePicker
                  label={getTranslation(
                    translations,
                    "pm.propertyeditor.specificproperties.label.select_date"
                  )}
                  slotProps={{
                    textField: {
                      size: "small", helperText: (!timeDateValue || isNaN(new Date(timeDateValue).getTime()))
                        ? getTranslation(
                          translations,
                          "generic.invalid_data.caption"
                        )
                        : undefined,
                    },
                  }}
                  minDate={dayjs(minDate) as any}
                  value={dayjs(timeDateValue || new Date()) as any}
                  onChange={onChangeSelectDate}
                />
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => onSaveDate(timeDateValue)}
                  disabled={!timeDateValue || isNaN(new Date(timeDateValue).getTime())}
                >
                  {getTranslation(translations, "pm.button.save")}
                </Button>
              </Stack>
            )}

            {timerType === "Cycle" && (
              <Typography variant="subtitle2">
                {getTranslation(
                  translations,
                  "pm.propertyeditor.specificproperties.label.timer_type.value"
                )}
              </Typography>
            )}
          </Stack>
        )}
        {getShouldShowTimerTypeField() && timerType === "Duration" && (
          <Stack mt={2} spacing={2}>
            <Typography variant="subtitle2">
              {getTranslation(
                translations,
                "pm.propertyeditor.specificproperties.label.select_duration"
              )}
            </Typography>
            <RenderDurationFields />
          </Stack>
        )}
        {getShouldShowTimerTypeField() && timerType === "Cycle" && (
          <TimerDefinitionSettings
            timerType={timerType}
            timeDateValue={timeDateValue}
            modeler={modeler}
            element={element}
          />
        )}
      </Collapse>
    </React.Fragment>
  );
};

export default SpecificPropertiesPanel;
